import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { useTranslation } from '../../i18n/translations';
import '../../styles/landing.css';

const Landing = () => {
    const navigate = useNavigate();
    const { language } = useLanguage();
    const { t } = useTranslation(language);

    // Desktop: niente splash → home. Mobile: resta sulla splash.
    useEffect(() => {
        const goHomeIfDesktop = () => {
            if (typeof window !== 'undefined' && window.innerWidth >= 769) {
                navigate('/home', { replace: true });
            }
        };
        goHomeIfDesktop();
        window.addEventListener('resize', goHomeIfDesktop);
        return () => window.removeEventListener('resize', goHomeIfDesktop);
    }, [navigate]);

    const handleEnter = () => {
        navigate('/home');
    };

    return (
        <div className="landing-container">
            <div className="landing-content">
                <div className="landing-visual">
                    <div className="landing-avatar-wrap">
                        <div className="landing-avatar">
                            <img
                                src={`${process.env.PUBLIC_URL}/img/mrFoundly.jpg`}
                                alt="Mr Foundly"
                            />
                        </div>
                        <span className="shadows-into-light-two-regular landing-byline">
                            {t('landing.byMrFoundly')}
                        </span>
                    </div>

                    <div className="logo-container">
                        <img
                            src={`${process.env.PUBLIC_URL}/img/logo.svg`}
                            alt="Foundly"
                            className="logo-svg"
                        />
                    </div>
                </div>

                <div className="landing-copy">
                    <p className="description">
                        {t('landing.tagline')}
                    </p>

                    <button
                        onClick={handleEnter}
                        className="enter-button"
                    >
                        {t('landing.discoverButton')}
                    </button>

                    <div className="landing-footer">
                        <a className="privacy-link" href="/privacy">
                            {t('privacy.linkLabel')}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Landing;
